export default {
    Presenting: [
        {
            title: 'University of Oregon',
            href: 'https://www.uoregon.edu/'
        }
    ],
    Platinum: [
        {
            title: 'Enjoy the Weather',
            href: 'http://www.enjoytheweather.com'
        },
        {
            title: 'Umpqua Bank',
            href: 'https://www.umpquabank.com'
        },
	    {
            title: 'Premier',
            href: 'https://www.premierpress.com/'
        },
     	{
            title: 'Victory',
            href: 'https://www.wearevictory.com/'
        },
        {
            title: 'Nike',
            href: 'http://www.nike.com'
        },
       {
            title: 'Lane Powell',
            href: 'http://www.lanepowell.com'
        },
        {
            title: 'Oregon Community Foundation',
            href: 'https://www.oregoncf.org/'
        }
    ],
    Gold: [
        {
            title: 'Arnerich Massena',
            href: 'http://arnerichmassena.com'
        },
        {
            title: 'Daimler',
            href: 'https://daimler-trucksnorthamerica.com/'
        },
        {
            title: 'Henry V Events',
            href: 'http://www.henryvevents.com'
        },
  	    {
            title: 'Oregonian Media Group',
            href: 'http://www.oregonlive.com'
        },
        {
            title: 'Rogue Ales',
            href: 'http://www.rogue.com'
        },
        {
            title: 'KGW',
            href: 'http://www.kgw.com'
        },
        {
            title: 'Audi Beaverton',
            href: 'http://www.audibeaverton.com'
        },
    	{
            title: 'Portland General Electric',
            href: 'https://www.portlandgeneral.com/'
        },
      	{
            title: 'Irving Street Kitchen',
            href: 'http://www.irvingstreetkitchen.com'
        },
        {
            title: 'Oregon Historical Society',
            href: 'http://www.ohs.org'
        },
        {
            title: 'Hyder Graphics',
            href: 'http://www.hydergraphics.com'
        },
        {
            title: 'Beam Suntory',
            href: 'http://www.beamsuntory.com'
        },
        {
            title: 'CB Solutions',
            href: 'http://www.cbsolutions-or.com/index.html'
        },
        {
            title: 'Stoller Family Estate',
            href: 'https://www.stollerfamilyestate.com'
        },
        {
            title: 'Provenance Hotels',
            href: 'http://provenancehotels.com'
        },
        {
            title: 'Planar',
            href: 'http://www.planar.com'
        },
        {
            title: 'Really BIG Video',
            href: 'http://rbvinc.com'
        },
        {
            title: 'Dehen 1920',
            href: 'https://www.dehen1920.com'
        },
        {
            title: 'Pacific Outdoor Advertising',
            href: 'http://www.pacificoutdooradvertising.com'
        },
        {
            title: 'Fuller Events',
            href: 'http://www.fullerevents.com'
        },
        {
            title: 'Alpha Sound',
            href: 'http://alphasound.org'
        },
        {
            title: 'Timberline Lodge',
            href: 'http://www.timberlinelodge.com'
        },
        {
            title: 'ZGF',
            href: 'https://www.zgf.com/'
        }
    ],
    Community: [
        {
            title: 'Edelman',
            href: 'https://www.edelman.com'
        },
        {
            title: 'Hydro Flask',
            href: 'https://www.hydroflask.com'
        },
        {
            title: 'Drink Shrub',
            href: 'https://www.drinkshrub.com/'
        },
	    {
            title: 'StoryTap',
            href: 'https://storytap.com/'
        },
	    {
            title: 'See See Motor Coffee Co.',
            href: 'https://www.seeseemotorcycles.com/'
        },
        {
            title: 'OMSI',
            href: 'http://www.omsi.edu'
        },
        {
            title: 'ClientJoy',
            href: 'https://www.clientjoy.com'
        },
        {
            title: 'KIND Snacks',
            href: 'http://www.kindsnacks.com'
        },
        {
            title: 'Belmont Blanket',
            href: 'http://www.belmontblanket.com'
        },
        {
            title: 'Space Monkey',
            href: 'http://www.spacemonkeydesigns.com'
        },
        {
            title: 'James Brand',
            href: 'http://www.thejamesbrand.com'
        },
        {
            title: 'Pinnacle Exhibits',
            href: 'http://www.pinnacle-exhibits.com'
        },
        {
            title: 'NWFilmCenter',
            href: 'https://nwfilm.org'
        },
        {
            title: 'Lyft',
            href: 'https://www.lyft.com'
        },
        {
            title: 'eggpress',
            href: 'https://www.eggpress.com'
        },
        {
            title: 'Rosemary Stafford Floral Design',
            href: 'http://rosemarystafford.com'
        },
        {
            title: 'Curate.org',
            href: 'https://curate.org'
        },
        {
            title: 'Portland Gear',
            href: 'https://portlandgear.com'
        },
        {
            title: 'Sofa Table Chair',
            href: 'https://www.sofatablechair.com/'
        },
        {
            title: 'Smith Tea',
            href: 'https://www.smithtea.com'
        },
        {
            title: 'Portland\'5',
            href: 'http://www.portland5.com'
        },
        {
            title: '503 Motoring',
            href: 'http://503motoring.com/'
        },
        {
            title: 'Red Bull',
            href: 'https://www.redbull.com/us-en/'
        },
        {
            title: 'Tillamook',
            href: 'https://www.tillamook.com'
        },
        {
            title: 'Spinklr',
            href: 'https://www.sprinklr.com'
        },
        {
            title: 'Feast Portland',
            href: 'https://www.feastportland.com/'
        },
        {
            title: 'Knot Springs',
            href: 'https://www.knotsprings.com/'
        },
        {
            title: 'Brew Dr. Kombucha',
            href: 'http://brewdrkombucha.com/'
      	},
        {
            title: 'Starbucks',
            href: 'https://www.starbucks.com/'
        },
	    {
            title: 'Burncycle',
            href: 'https://burn-cycle.com/'
        },
	    {
            title: 'The Cribbage Maan',
            href: 'https://www.thecribbagemaan.com/'
        }
        

    ]
}